import { erpAxios } from '.';

const getIzvorPrihoda = async () => {
  const { data } = await erpAxios(`/gr-izvor-prihoda/izvorPrihoda`);
  return data;
};

export default getIzvorPrihoda;
